import {Button} from '@dropbox/dig-components/buttons';
import {List} from '@dropbox/dig-components/list';
import {Box, Stack} from '@dropbox/dig-foundations';
import {useMutation, useQuery} from '@tanstack/react-query';
import {NotificationService} from 'client';
import {Eyebrow} from 'components/DSYS/Eyebrow';
import {t} from 'i18next';
import {getService} from 'utilities';
import {queryClient} from 'views/QueryClientWrapper';

import {NotificationEmptyState} from './NotificationEmptyState';
import {NotificationRenderer} from './NotificationRenderer';
import {useVisibleNotifications} from './utils/useVisibleNotifications';

export const NotificationInbox = ({handleSelection}: {handleSelection: () => void}) => {
  const {data} = useQuery({
    queryKey: ['notifications'],
    queryFn: getService(NotificationService).checkApiV1NotificationsGet,
  });
  const {actionItems: visibleActionItems, notifications: visibleNotifications} =
    useVisibleNotifications(data);

  const {mutate: archiveAll} = useMutation({
    mutationFn: getService(NotificationService).archiveAllApiV1NotificationsArchiveGet,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['notifications']});
    },
  });

  return (
    <Stack>
      {!visibleActionItems.length ? null : (
        <Box paddingTop="12">
          <Box paddingX="16">
            <Eyebrow>{t('notification_action_items_header')}</Eyebrow>
          </Box>
          <List padding="0">
            {visibleActionItems.map((item, index) => (
              <NotificationRenderer
                key={item.id}
                notification={item}
                separator={index < visibleActionItems.length - 1}
                onClick={handleSelection}
              />
            ))}
          </List>
        </Box>
      )}
      {!visibleNotifications.length ? null : (
        <Box paddingTop="12">
          <Box paddingX="16" display="flex" justifyContent="space-between" alignItems="center">
            <Eyebrow>{t('notification_notifications_header')}</Eyebrow>
            <Button size="small" variant="transparent" onClick={() => archiveAll()}>
              {t('notification_archive_all')}
            </Button>
          </Box>
          <List padding="0">
            {visibleNotifications.map((item, index) => (
              <NotificationRenderer
                key={item.id}
                notification={item}
                archiveable
                separator={index < visibleNotifications.length - 1}
                onClick={handleSelection}
              />
            ))}
          </List>
        </Box>
      )}

      {visibleActionItems.length || visibleNotifications.length ? null : (
        <NotificationEmptyState type="inbox" />
      )}
    </Stack>
  );
};
